import { ProcessingLevel } from "@redotech/cockroachdb-codegen/tables/fulfillment/processing-level";
import * as z from "zod";

export const RETURN_PROCESSING_LEVEL_PATH =
  "redoManagedReturns.returnProcessingLevel";

/** Admin/CRDB processing level, including receiving. Not the Mongo product enum. */
export const returnProcessingLevelSchema = z.enum(ProcessingLevel);

export function isReturnProcessingLevelPath(path: string): boolean {
  return path === RETURN_PROCESSING_LEVEL_PATH;
}

export function parseReturnProcessingLevelValue(
  value: unknown,
): ProcessingLevel {
  return returnProcessingLevelSchema.parse(value);
}

export function diffReturnProcessingLevel(
  stored: ProcessingLevel,
  next: ProcessingLevel | null | undefined,
): { path: string; prev: ProcessingLevel; next: ProcessingLevel }[] {
  if (next == null || stored === next) {
    return [];
  }
  // Product reads map CRDB receiving to verification. Submitting that mapped
  // value must not look like a change back to verification.
  if (
    stored === ProcessingLevel.Receiving &&
    next === ProcessingLevel.Verification
  ) {
    return [];
  }
  return [{ path: RETURN_PROCESSING_LEVEL_PATH, prev: stored, next }];
}
